import QS from 'qs'
import axios from 'axios'
import $toast from '../views/common/Toast'
// import $dialog from '../views/common/Install'
import { getCommonInfo, getAuthTime } from '@/assistant/JSBridge'

axios.defaults.baseURL = '/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

let api = axios.create({
  baseURL: '/',
  timeout: 10000,
  transformRequest: [
    function (data) {
      data = QS.stringify(data)
      return data
    }
  ]
})

const ensureNoLoading = () => {
  return new Promise((resolve) => {
    let e = document.querySelector('[von-loading]')
    if (e) {
      setTimeout(() => {
        // $loading.hide()
        setTimeout(() => { resolve() }, 600)
      }, 300)
      return
    }
    resolve()
  })
}

export const getAUTH = () => {
  return new Promise((resolve) => {
    let arr = {
      'auth': '',
      'appv': '',
      'time': ''
    }
    let p1 = getCommonInfo([])
    let p2 = getAuthTime()
    Promise.all([p1, p2]).then((result) => {
      const data = Object.assign({}, ...result)
      arr.time = data['timestamp']
      arr.auth = data['IDFA'] + '|' + data['UUID']
      arr.appv = data['DeviceModel'] + '|' + data['OSVer'] + '|' + data['BundleID'] + '|' + data['BundleVer'] + '|' + data['BundleBuild'] + '|' + data['WebVer']
      resolve(arr)
    })
  })
}

api.interceptors.request
  .use((config) => {
    return getAUTH()
      .then(res => {
        config.headers['X-DP-AUTH'] = res.auth
        config.headers['X-DP-APPV'] = res.appv
        config.headers['X-DP-TIME'] = res.time
        return config
      })
  }, (err) => { // eslint-disable-line handle-callback-err
    // TODO:
    // Just swallow the err
    return Promise.reject(err)
  })

api.interceptors.response
  .use((res) => {
    return res
  }, (err) => {
    // Process error:
    let res = err.response
    let config = err.config
    if (config.no_error_handler) return Promise.reject(err)

    if (res) {
      if (res.status === 400) {
        ensureNoLoading().then(() => $toast.show((res.data && res.data.err_msg) || '错误的请求'))
      } else if (res.status === 401) { // 用户未登录
        $router.push('/installAuth/0')
      } else if (res.status === 402) {
        ensureNoLoading().then(() => {
          const duration = 2000
          $toast.show('检测到设备越狱，请恢复到正版继续试玩', duration)
          setTimeout(() => {
            $router.push('/dashboard')
          }, duration + 500)
        })
      } else if (res.status === 500) {
        ensureNoLoading().then(() => $toast.show('服务器内部错误'))
      } else if (res.status === 502) {
        ensureNoLoading().then(() => $toast.show('连接超时，请检查网络'))
      } else {
        ensureNoLoading().then(() => $toast.show('未知错误'))
        throw err
      }
    } else {
      ensureNoLoading().then(() => $toast.show('连接超时，请检查网络'))
    }

    return Promise.reject(err)
  })

export default api
